<template>
  <div class="syanai-notes edit-item" v-if="editingData">

    <div class="head"><b>社内メモ欄<br>（備考、変更理由等）</b></div>
    <div class="data">
      <input-textarea :disabled="disabled" v-model="editingData.syanai_notes"
        :error="getError(editingData, 'syanai_notes')"></input-textarea>
      <p class="current-data pre" v-if="currentData?.syanai_notes">{{ currentData.syanai_notes }}</p>
    </div>

  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();

    return {
      getError
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>
